// IE 2026 10 14 / ODOO-5800 (Igor: правка строк «динамических списков» — гридов ленивых вкладок с saveMethod — должна быть однотипной с «виджетом списка»):
// режим редактирования такого грида как у списка записей сегмента: по умолчанию read-only (viewParams.<grid>.isReadOnly не задан → true), в панели —
// «Edit in a grid» (set_viewParam isReadOnly=false, тот же вид и help, что у серверной кнопки списка widgets.py), в режиме правки — Save (жёлтая дискета, бейдж N,
// executeVueObjMethod gridSave_save) и Cancel (крестик, gridEditMode_cancel); первая правка ячейки включает режим сама (общий setModified → set_viewParam isReadOnly=false,
// _roBefore возвращает режим после Save / Cancel). Жёлтая полоса grid-save-bar при включённом флаге не показывается. Чипс «Corrections» (бейдж, ←/→) — и у таких гридов,
// per-binding (WIDGET._dd_info_chips[]._binding). Открытие записи строки — как «Open» / карандаш заголовка строки списка: widget_open widget-record с item {id, segment}.
// Флаг fe.ux.gridEditMode (дефолт ВКЛ); выкл — поведение прежнее (полоса Save / Discard, кнопки строк видны всегда). Чистые функции — юнит tests/unit/gridEditMode.test.mjs
export const GRID_EDIT_MODE_FLAG = 'fe.ux.gridEditMode'   // IE 2026 10 14 / ODOO-5800

export function gridEditMode_on(setting) {   // IE 2026 10 14 / ODOO-5800: чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(GRID_EDIT_MODE_FLAG, true) !== false : true } catch (e) { return true }
}

// режим применим: флаг ВКЛ и у грида есть метод сохранения (gridSaveBar.gridSave_method)
export function gridEditMode_applies({ flagOn = true, saveMethod = '' } = {}) {   // IE 2026 10 14 / ODOO-5800
    return flagOn !== false && !!(typeof saveMethod === 'string' && saveMethod.trim())
}

// isReadOnly грида: явное значение viewParams (true / false) — как есть; не задано → в режиме редактирования списка грид read-only, иначе def (как было)
export function gridEditMode_readOnly(raw, applies, def = false) {   // IE 2026 10 14 / ODOO-5800
    if (raw !== undefined && raw !== null) return raw
    return applies ? true : def
}

const _str = (v) => (v === undefined || v === null) ? '' : String(v).trim()

// ссылка записи строки: {kind:'record', id, segment} строки (_link / link), иначе id строки + сегмент строки (segment) или грида (recordSegment / relation_segment / segment)
export function gridEditMode_rowLink(row, attr = null) {   // IE 2026 10 14 / ODOO-5800
    if (!row || typeof row !== 'object') return null
    for (const l of [row._link, row.link]) {
        if (l && typeof l === 'object' && (l.kind === 'record' || !l.kind) && _str(l.id) && _str(l.segment)) return { id: _str(l.id), segment: _str(l.segment) }
    }
    const id = _str(row.id)
    if (!id) return null
    const seg = _str(row.segment) || _str(attr?.recordSegment) || _str(attr?.relation_segment) || _str(attr?.segment)
    return seg ? { id, segment: seg } : null
}

// открытие записи строки предлагается: у грида известен сегмент записей либо строки (первые 50) несут segment / ссылку записи
export function gridEditMode_openPossible(attr, rows) {   // IE 2026 10 14 / ODOO-5800
    if (_str(attr?.recordSegment) || _str(attr?.relation_segment) || _str(attr?.segment)) return true
    const list = Array.isArray(rows) ? rows.slice(0, 50) : []
    return list.some((r) => !!gridEditMode_rowLink(r, null))
}

// действие двойного клика / карандаша заголовка строки: открыть запись строки (executeVueObjMethod gridEditMode_openRecord грида)
export function gridEditMode_openAction({ sourceName = '', binding = '', t = (s) => s } = {}) {   // IE 2026 10 14 / ODOO-5800
    return { tooltip: t('Open record'), action_name: 'action-front-openRecord-2026-10-14', command: 'executeVueObjMethod', method: 'gridEditMode_openRecord',
        cssClass: 'pi p-button-white pi-arrow-right', source_name: sourceName, binding, _openRecord: true }
}

// действие открытия записи (widget_open widget-record с item, как Open / карандаш списка записей сегмента и cellLink_open)
export function gridEditMode_openItemAction(link) {   // IE 2026 10 14 / ODOO-5800
    if (!link || !_str(link.id) || !_str(link.segment)) return null
    return { command: 'widget_open', widget: 'widget-record', _activate: true, open_in_children_widget: true, item: { id: _str(link.id), segment: _str(link.segment) } }
}

// кнопки командной панели режима: read-only → «Edit in a grid» (+ «Open record», когда открытие возможно); режим правки → Save (N) + Cancel
export function gridEditMode_buttons({ applies = true, readOnly = true, count = 0, saving = false, attrName = '', binding = '', open = false, t = (s, p) => s } = {}) {   // IE 2026 10 14 / ODOO-5800
    if (!applies) return []
    const base = { autoGeneratedButton: true, attr_type: 'AttrButton', source_name: attrName, binding }
    if (readOnly) {
        const out = [{ ...base, name: 'button-gridEditMode_edit', tooltip: t('Edit in a grid'), command: 'set_viewParam', binding: `doc.viewParams.${attrName}.isReadOnly`, setValue: false,
            cssClass: 'pi p-button-main pi-file-edit', uiHelp: 'grid.cmd.readOnlyOff', _gridEditMode: 'edit' }]
        if (open) out.push({ ...base, name: 'button-gridEditMode_open', tooltip: t('Open record'), command: 'executeVueObjMethod', method: 'gridEditMode_openRecord',
            cssClass: 'pi p-button-white pi-arrow-right', enabled_when: [{ field: 'id', nonempty: true }], uiHelp: 'grid.cmd.openRecord', _gridEditMode: 'open' })
        return out
    }
    const n = Number(count) || 0
    return [
        { ...base, name: 'button-gridEditMode_save', tooltip: n ? t('Save ({n})', { n }) : t('Save'), command: 'executeVueObjMethod', method: 'gridSave_save',
            cssClass: n ? 'pi p-button-yellow p-button-main pi-save' : 'pi p-button-white pi-save', disabled: !n || saving === true, countItems: n, uiHelp: 'grid.cmd.editSave', _gridEditMode: 'save' },
        { ...base, name: 'button-gridEditMode_cancel', tooltip: n ? t('Cancel: discard the changes and restore the loaded rows') : t('Cancel: back to read-only'), command: 'executeVueObjMethod', method: 'gridEditMode_cancel',
            cssClass: 'pi p-button-white pi-times', disabled: saving === true, uiHelp: 'grid.cmd.editCancel', _gridEditMode: 'cancel' },
    ]
}

// чипс WIDGET._dd_info_chips показывается на гриде с привязкой binding: чипс без _binding — на любом (как было), с _binding — только на своём
export function gridEditMode_chipVisible(info, binding) {   // IE 2026 10 14 / ODOO-5800
    if (!info || typeof info !== 'object') return false
    const b = _str(info._binding)
    return !b || b === _str(binding)
}

// чипсы WIDGET._dd_info_chips для грида с привязкой binding: основная таблица отчёта / списка (host — dataSheet, как было) — все видимые по gridEditMode_chipVisible;
// прочие встроенные гриды (динамические списки ленивых вкладок) — только чипсы СО СВОЕЙ _binding (без _binding — чипсы основной таблицы, на вкладках их не показывать)
export function gridEditMode_ddChips(list, binding, host = false) {   // IE 2026 10 14 / ODOO-5800 (бот dev02, п.4: чипс Corrections на вкладке не рендерился — AttrChips собирал info-чипсы только у dataSheet)
    const arr = Array.isArray(list) ? list : []
    return arr.filter((info) => gridEditMode_chipVisible(info, binding) && (host || !!_str(info._binding)))
}
